/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
import { Children } from '@instructure/ui-prop-types';
import { PaginationButton } from './PaginationButton';
const propTypes = {
  children: Children.oneOf([PaginationButton]),
  disabled: PropTypes.bool,
  withFirstAndLastButton: PropTypes.bool,
  showDisabledButtons: PropTypes.bool,
  label: PropTypes.node,
  labelNext: PropTypes.string,
  labelPrev: PropTypes.string,
  labelFirst: PropTypes.string,
  labelLast: PropTypes.string,
  labelNumberInput: PropTypes.func,
  screenReaderLabelNumberInput: PropTypes.func,
  screenReaderLabelPageButton: PropTypes.func,
  variant: PropTypes.oneOf(['full', 'compact', 'input']),
  margin: PropTypes.string,
  as: PropTypes.elementType,
  elementRef: PropTypes.func,
  inputRef: PropTypes.func,
  shouldHandleFocus: PropTypes.bool,
  totalPageNumber: PropTypes.number,
  currentPage: PropTypes.number,
  siblingCount: PropTypes.number,
  boundaryCount: PropTypes.number,
  onPageChange: PropTypes.func,
  renderPageIndicator: PropTypes.func,
  ellipsis: PropTypes.node
};
const allowedProps = ['children', 'disabled', 'withFirstAndLastButton', 'showDisabledButtons', 'label', 'labelNext', 'labelPrev', 'labelFirst', 'labelLast', 'labelNumberInput', 'screenReaderLabelNumberInput', 'screenReaderLabelPageButton', 'variant', 'margin', 'as', 'elementRef', 'inputRef', 'shouldHandleFocus', 'totalPageNumber', 'currentPage', 'onPageChange', 'siblingCount', 'boundaryCount', 'renderPageIndicator', 'ellipsis'];
export { propTypes, allowedProps };